var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE00",
    d: "M10.3,3.9L1.8,18c-0.6,1-0.2,2.2,0.7,2.7c0.3,0.2,0.6,0.3,1,0.3h16.9c1.1,0,2-0.9,2-2c0-0.3-0.1-0.7-0.3-1 L13.7,3.9C13.1,3,11.9,2.7,11,3.2C10.7,3.4,10.5,3.6,10.3,3.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5L14.6,3.4c-0.9-1.3-2.5-1.8-4.1-1c-0.4,0.3-0.7,0.6-1,1L1,17.5c-0.4,0.7-0.5,1.5-0.3,2.3c0.2,0.8,0.7,1.4,1.3,1.8 C2.5,21.9,3,22,3.5,22h16.9c1.7,0,3-1.3,3-3C23.4,18.5,23.3,17.9,23,17.5z M20.4,20H3.5c-0.2,0-0.3,0-0.5-0.2 c-0.2-0.1-0.4-0.3-0.4-0.6c0-0.2-0.1-0.4,0.1-0.7l8.5-14.1c0.1-0.2,0.2-0.3,0.4-0.4C11.7,4,11.8,4,12,4c0.4,0,0.7,0.2,0.9,0.5 l8.4,14.1c0.1,0.1,0.1,0.3,0.1,0.4C21.4,19.6,21,20,20.4,20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1s1-0.4,1-1V9C13,8.5,12.6,8,12,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,16.3C11.1,16.5,11,16.8,11,17c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7C12.3,15.9,11.7,15.9,11.3,16.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.05c1ec11f232f89f53762aab0302f59c.svg";
export { ForwardRef as ReactComponent };